import { useMemo, useState } from 'react';
import { SimpleTable } from '../k2/K2Tables';
import { fmtCz, fmtKc } from '../k2/k2utils';
import { Panel, SearchBox } from './PartnerRanking';
import { LinesDialog } from './LinesDialog';

export const DocsPanel = ({ title, docs, columns, items, partnerLabel, docsByRid }) => {
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(null);
  const rows = useMemo(() => {
    const ql = q.toLowerCase();
    return docs.filter((r) => !ql || `${r.doc} ${r.partner} ${r.description}`.toLowerCase().includes(ql));
  }, [docs, q]);
  const lines = open && items ? items.filter((x) => x.doc_rid === open.rid) : [];
  return (
    <Panel title={title} subtitle={`${rows.length} dokladů · celkem ${fmtKc(rows.reduce((a, r) => a + r.amount, 0))}${items ? ' · kliknutím zobrazíte položky' : ''}`}
      testId="an-docs" right={<SearchBox value={q} onChange={setQ} testId="an-docs-search" />}>
      <SimpleTable key={q + docs.length} testId="an-docs-table" columns={columns} rows={rows} rowKey={(r) => r.rid} onRowClick={items ? setOpen : undefined} />
      {items && (
        <LinesDialog open={!!open} onClose={() => setOpen(null)} lines={lines} showArticle testId="an-doc-detail"
          title={open ? `Doklad ${open.doc}` : ''} docsByRid={docsByRid} partnerLabel={partnerLabel}
          subtitle={open ? [fmtCz(open.date), open.partner, open.warehouse, open.description].filter(Boolean).join(' · ') : ''} />
      )}
    </Panel>
  );
};
